import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { AssetIcon } from '@/presentation/components/common/icon/AssetIcon';
import { ANIMATION_CONSTANTS } from '@/presentation/constants/animationConstants';
import { qaAttr, type QaAttrOptions } from '@/presentation/utils/qaAttr';

interface BackIconButtonProps {
  onClick?: () => void;
  /**
   * `data-qa-*` set for the back `<button>`. Defaults to `{ id: 'back-button' }`
   * so every page's back control is findable without per-call-site work;
   * override when a page has more than one back affordance.
   */
  qa?: QaAttrOptions;
}

export const BackIconButton = ({ onClick, qa = { id: 'back-button' } }: BackIconButtonProps) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();

  return (
    <button
      {...qaAttr(qa)}
      onClick={onClick}
      style={{
        padding: responsive.spacing.sm,
        borderRadius: responsive.borderRadius.round,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
      }}
    >
      <AssetIcon
        path="/assets/images/arrow_up.png"
        width={responsive.icon.large}
        height={responsive.icon.large}
        color={theme.text.primary}
        rotationAngle={ANIMATION_CONSTANTS.rotation.left}
      />
    </button>
  );
};
